// extracted by mini-css-extract-plugin
export default {"illustration":"UserOnboardingNameSlide_illustration__BjNKA"};